/** Token classes map to semantic colour tokens only — never a raw hex. */
export type TokenKind = 'plain' | 'comment' | 'string' | 'number' | 'keyword' | 'fn' | 'punct';

export const TOKEN_CLASS: Record<TokenKind, string> = {
  plain: 'text-foreground',
  comment: 'italic text-muted-foreground',
  string: 'text-success',
  number: 'text-warning',
  keyword: 'text-primary',
  fn: 'text-info',
  punct: 'text-muted-foreground',
};

const JS = 'as async await break case catch class const continue default delete do else enum export extends false finally for from function if implements import in instanceof interface let new null of return static super switch this throw true try type typeof undefined var void while yield';
const PY = 'and as assert async await break class continue def del elif else except False finally for from global if import in is lambda None not or pass raise return True try while with yield';
const SQL = 'select from where group by order having join left right inner outer on as insert into values update set delete create table alter drop index primary key foreign references not null distinct limit offset union all case when then end';
const SH = 'if then else fi for while do done case esac function return export local echo cd set unset source exit';
const GO = 'break case chan const continue default defer else fallthrough for func go goto if import interface map package range return select struct switch type var nil true false';

/** Language aliases → keyword set. Anything unknown highlights strings/comments only. */
export const KEYWORDS: Record<string, ReadonlySet<string>> = {
  js: new Set(JS.split(' ')),
  ts: new Set(JS.split(' ')),
  tsx: new Set(JS.split(' ')),
  jsx: new Set(JS.split(' ')),
  json: new Set(['true', 'false', 'null']),
  py: new Set(PY.split(' ')),
  python: new Set(PY.split(' ')),
  sql: new Set(SQL.split(' ')),
  sh: new Set(SH.split(' ')),
  bash: new Set(SH.split(' ')),
  go: new Set(GO.split(' ')),
};

/** Comment syntax per language family. */
export function commentStyle(language: string): 'slash' | 'hash' | 'dash' {
  if (language === 'py' || language === 'python' || language === 'sh' || language === 'bash') return 'hash';
  if (language === 'sql') return 'dash';
  return 'slash';
}

export const LANGUAGE_LABEL: Record<string, string> = {
  js: 'JavaScript', ts: 'TypeScript', tsx: 'TSX', jsx: 'JSX', json: 'JSON',
  py: 'Python', python: 'Python', sql: 'SQL', sh: 'Shell', bash: 'Bash', go: 'Go',
  html: 'HTML', css: 'CSS', yaml: 'YAML', md: 'Markdown',
};
